/**
 *
 * @overview 工具包
 * @author mll
 * @date 2019-8-23
 */

import { utils_tool, framework_tool } from '../tool'

let {
    getPropOfObjectByStr, setPropOfObjectByStr, isEqual, generateUUID,
    stringToJson, jsonToString, mapToJson, jsonToMap, strMapToObj, objToStrMap, convertNumToCn,
    fromJS, Map, is, List, isImmutable,
    log,
    network,
    dateUtils,
    Storage,
    $$
} = utils_tool;

let { request, actionUtils, modelUtils } = framework_tool

import { routerRedux } from 'dva/router';
// import packMock from './mock/packMock'
import { downLoadBiz } from './download'

import { exportPdf } from './pdf'
import {seatsOut} from './seatsOut'

export {
    //wiz-utils
    getPropOfObjectByStr, setPropOfObjectByStr, isEqual, generateUUID,
    stringToJson, jsonToString, mapToJson, jsonToMap, strMapToObj, objToStrMap, convertNumToCn,
    fromJS, Map, is, List, isImmutable,
    log,
    network,
    dateUtils,
    Storage,
    $$,
    request,
    //others-utils
    actionUtils,
    modelUtils,
    routerRedux,
    // packMock,
    downLoadBiz,
    exportPdf,
    seatsOut,
};

export default {};
